import { SetStateAction, Dispatch } from 'react'
import client from 'api/client'
import { reportError } from 'utils/error'
import { showErrorMessageToast } from 'common/MessageToasts/ErrorMessageToast/ErrorMessageToast'
import { showToastMessage } from 'common/ToastMessage/ShowToastMessage'

export const emptyFormState = (fields: any, initial: any, setEditFun: Dispatch<SetStateAction<any>>) => {
  return setEditFun(
    Object.keys(fields).reduce((acc: {}, field: any) => {
      const value = initial[`${Object.keys(initial).find((key) => key === field)}`] ? null : ''
      if (value !== null || value !== '')
        return { ...acc, [field]: initial[`${Object.keys(initial).find((key) => key === field)}`] }
      return { ...acc, [field]: value }
    }, {}),
  )
}

export const handleProfileSave = async (body: {}) => {
  try {
    const response = await client.updateUserProfile(body)
    if (response.type === 'success') return showToastMessage('Profile updated', 'success')
    return showErrorMessageToast('Something went wrong 😢')
  } catch (error) {
    reportError(error, { severity: 'error', metaData: { info: 'updateUserProfile' } })
  }
}

/**
 * Fetches user profile information and sets initial state
 * @param id - user id
 * @param setProfileInformation - setStateAction function
 */
export const fetchUserProfile = async (id: number, setStateFunc: Dispatch<SetStateAction<any>>) => {
  try {
    const response = await client.getUserProfile(id)
    if (response.type !== 'success')
      return setStateFunc({
        first_name: '',
        last_name: '',
        bio: '',
        company: '',
        linked: '',
        twitter: '',
      })
    const { data } = response
    const { user } = data
    const { first_name, last_name, bio, company_name, linkedin, twitter, email_visible, email } = user
    return setStateFunc({
      first_name,
      last_name,
      bio,
      company: company_name,
      linkedin,
      twitter,
      email_visible,
      email,
    })
  } catch (error) {
    reportError(error, { severity: 'error', metaData: { info: 'getProfileInformationService' } })
  }
}
